import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import RolePermissionsForm from '@app/components/apps/Users/UserRolesForm';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Col, Row } from 'antd';
import { BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';

export const ViewUserRolePage: React.FC = () => {
  const location = useLocation();
  const { id } = location.state || {};
  const { t } = useTranslation();

  const routes = [
    {
      path: '/user-roles',
      breadcrumbName: 'User Roles',
    },
    {
      path: '/view-role',
      breadcrumbName: 'View User Role',
    },
  ];

  return (
    <>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <BaseBreadcrumbWithRender routes={routes} separator=">" />
        </Col>
        <RolePermissionsForm type={'view'} editable={false} id={id} pageTitle={`View Role & Permissions`} />
      </Row>
    </>
  );
};

export default ViewUserRolePage;
